import { Button, Col, Row } from "antd";
import React, {
  ReactNode,
  Ref,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";

import BaseModal, { BaseModalRef, InternalModalProps } from "./BaseModal";

interface SuccessPopupProps extends Partial<InternalModalProps> {
  title?: string;
  afterClose?: () => void;
  onOk?: (e?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  okText?: string;
}

const SuccessPopup = forwardRef(function SuccessPopup(
  { title = "Success", afterClose, onOk, okText, ...props }: SuccessPopupProps,
  ref: Ref<BaseModalRef>,
) {
  const type = "success";
  const thisRef = useRef<BaseModalRef>(null);
  useImperativeHandle(ref, () => ({
    close: () => thisRef.current?.close(),
  }));

  let footer: ReactNode = null;
  if (okText) {
    footer = [
      <Row className="m-t-m m-b-m" key="footer-row">
        <Col span={24} className="text-right">
          <Button
            key="submit"
            type="primary"
            onClick={(e) => {
              onOk && onOk(e);
              thisRef.current?.close();
            }}
            danger={true}
          >
            {okText}
          </Button>
        </Col>
      </Row>,
    ];
  }

  const baseModalProps = {
    title: title,
    className: type + "-popup",
    footer,
    afterClose,
    ...props,
  };

  return (
    <BaseModal
      modalProps={baseModalProps}
      afterClose={afterClose}
      ref={thisRef}
    >
      {props.children}
    </BaseModal>
  );
});

export default SuccessPopup;
